module.exports = __webpack_public_path__ + "img/show_app_pic.6c797232.png";